import Request from "../Request.js";

const subscriptions = {
  // Add-on flags only (solarModeEnabled, airteamDesignerEnabled, ...). Readable by
  // every user of the company, unlike the full subscription which is admin-only.
  getCompanyAddons(companyId) {
    return Request.get(`/api/v2/subscription/company/${companyId}/addons/`);
  },
};

export default subscriptions;
